<template>
  <layout name="Sidebar">
    <VTableView
      :sidebar="{
        buttons,
        title: 'Campaigns',
        extraClass: 'campaigns-layout-heading'
      }"
      :withPagination="
        (pagination.total_count > 25 && itemsPerPage > 25) ||
          pagination.page_count > 1
      "
    >
      <template slot="search">
        <CampaignsFilter />
      </template>

      <template slot="table">
        <CampaignsTable
          extraClass="campaigns-table"
          @edit="handleEditCampaign"
        ></CampaignsTable>
      </template>

      <template slot="pagination">
        <CampaignsPagination />
      </template>

      <template slot="extra">
        <CampaignsCreateNewModal
          :opened="campaignsCreateOpened"
          @close="campaignsCreateOpened = false"
        />
      </template>
    </VTableView>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import { mapGetters } from "vuex";

import VTableView from "@/views/VTableView";

import withNavigate from "@/mixins/withNavigate";

// components
import VSidebarLayoutHeading from "@/components/VSidebarLayoutHeading";
import CampaignsTable from "@/components/CampaignsTable";
import CampaignsFilter from "@/components/CampaignsFilter";
import CampaignsCreateNewModal from "@/components/CampaignsCreateNewModal";
import CampaignsPagination from "@/components/CampaignsPagination";

export default Vue.component("Campaigns", {
  metaInfo: {
    title: "Campaigns"
  },

  components: {
    Layout,
    VTableView,
    VSidebarLayoutHeading,
    CampaignsTable,
    CampaignsFilter,
    CampaignsPagination,
    CampaignsCreateNewModal
  },

  mixins: [withNavigate],

  data() {
    return {
      campaignsCreateOpened: false,
      campaignId: null,
      buttons: [
        {
          key: "new-campaign",
          type: "primary",
          label: "New Campaign",
          size: "regular",
          onClickHandler: this._openModal,
          extraClass: "new-campaign"
        }
      ]
    };
  },

  methods: {
    _openModal(e, key) {
      this.campaignsCreateOpened = true;
      this.campaignId = null;
    },

    handleEditCampaign(e, id) {
      e.preventDefault();
      this.campaignId = id;
      this.campaignsCreateOpened = true;
    }
  },

  computed: {
    ...mapGetters("campaigns", [
      "isLoading",
      "templatesList",
      "pagination",
      "search",
      "sort"
    ]),

    ...mapGetters("service", ["itemsPerPage"])
  }
});
</script>

<style lang="scss">
.campaigns-table {
  @media screen and (max-width: 960px) {
    overflow: auto;
  }
}
</style>
